const state = {
  plainrawMaterials: [],
  rawMaterials: [],
  rawMaterial: {},
  getRawMaterialLoading: false
};

export default {
  namespaced: true,
  state,
  mutations: {
    setRawMaterials(state, rawMaterials) {
      state.rawMaterials = rawMaterials;
    },
    setRawMaterial(state, rawMaterial) {
      state.rawMaterial = rawMaterial;
    },
    setPlainRawMaterials(state, rawMaterials) {
      state.plainrawMaterials = rawMaterials;
    },
    setGetRawMaterialLoading(state, loading) {
      state.getRawMaterialLoading = loading;
    }
  },
  actions: {
    fetchRawMaterials({ commit, rootState }, payload) {
      const { dontPaginate, filter, page, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/rawmaterial', {
              params: { page: page, filter: filter, paginationcount: paginationcount }
            })
            .then(response => {
              commit('setRawMaterials', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {
              commit('SET_LOADING', false, { root: true });
            });
        }
        return axios
          .get('api/v1/rawmaterial', { params: { page: page, paginationcount: paginationcount } })
          .then(response => {
            commit('setRawMaterials', response.data);
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        return axios.get('api/v1/rawmaterial', { params: { paginate: 0 } }).then(response => {
          commit('setPlainRawMaterials', response.data);
        });
      }
    },
    getRawMaterial({ commit }, payload) {
      commit('setGetRawMaterialLoading', true);
      return axios
        .get(`api/v1/rawmaterial/${payload.id}`)
        .then(response => {
          commit('setRawMaterial', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setRawMaterial', {});
          }
        })
        .finally(() => {
          commit('setGetRawMaterialLoading', false);
        });
    }
  }
};
